export default __webpack_public_path__ + "static/media/thumbnail_7.7adc9e66.webp";